// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MYf0R","row":"styles_row__yTVns","rowCurrency":"styles_rowCurrency__rczPB"};